import React, { useState } from 'react';
import { Field, useFormikContext } from 'formik';
import { Form as BulmaForm } from '@codeparva/ui-components-library';
import { FormFieldsTypes } from './FormFieldsTypes';
import { FontAwesomeIcon } from '../../utilities/iconLoader/FontAwesomeIcon';
import { getAsterisk } from './helper/GetAstrisk';
import { GetErrorMessageIcon } from './helper/GetErrorMessageIcon';
import ReactTooltip from 'react-tooltip';

export const TextField = ({
  name,
  label,
  required,
  type = 'input',
}: FormFieldsTypes.ITextField) => {
  let { errors }: any = useFormikContext();
  const [passwordShown, setPasswordShown] = useState(false);

  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };

  const getLabel = () => {
    if (name === 'OtherInfo_NewPassword') {
      return (
        <span className={`is-flex ${name}`}>
          <label htmlFor={name} data-cy={`${name}-${required}`}>
            {label}
            {required && getAsterisk()}
          </label>
          <span
            data-tip
            data-for="passwordTip"
            className="pl-2 has-text-primary"
          >
            <FontAwesomeIcon
              iconClassName="FaInfoCircle"
              iconContextProps={{
                className: 'has-text-primary',
              }}
            />
          </span>
          <ReactTooltip
            className="passwordTipClass"
            id="passwordTip"
            type="light"
            effect="solid"
            backgroundColor="white"
            getContent={function() {
              return (
                <>
                  <p className="passwordPara">Adhere to password policy:</p>
                  <ul className="passwordPolicyList">
                    <li>
                      Password length should be in between 8-20 characters.
                    </li>
                    <li>
                      Password should contain atleast one,
                      <ul className="passwordTypeList">
                        <li>Number.</li>
                        <li>Capital Letter.</li>
                        <li>Special Character.</li>
                      </ul>
                    </li>
                    <li>Password shouldn't be same as previous 5 passwords.</li>
                    <li>Password shouldn't contain any common words.</li>
                    <li>Password shouldn't contain username or email ID.</li>
                  </ul>
                </>
              );
            }}
          ></ReactTooltip>
        </span>
      );
    } else if (name === 'OtherInfo_EmailAddress') {
      return (
        <span className={`is-flex ${name}`}>
          <label htmlFor={name} data-cy={`${name}-${required}`}>
            {label}
            {required && getAsterisk()}
          </label>
          <span data-tip data-for="emailTip" className="pl-2 has-text-primary">
            <FontAwesomeIcon
              iconClassName="FaInfoCircle"
              iconContextProps={{
                className: 'has-text-primary',
              }}
            />
          </span>
          <ReactTooltip
            className="passwordTipClass"
            id="emailTip"
            type="light"
            effect="solid"
            backgroundColor="white"
            getContent={function() {
              return (
                <p className="passwordPara">
                  Email address can be changed in the Tenant Information
                  section.
                </p>
              );
            }}
          ></ReactTooltip>
        </span>
      );
    } else {
      return (
        <label htmlFor={name} data-cy={`${name}-${required}`}>
          {label}
          {required && getAsterisk()}
        </label>
      );
    }
  };

  const { Input } = BulmaForm;
  return (
    <>
      {label && getLabel()}

      {type === 'password' ? (
        <div className="control has-icons-right">
          <Field
            type={passwordShown ? 'text' : 'password'}
            name={name}
            id={name}
            as={Input}
          />
          <span className="icon is-small is-right">
            <a type="button" onClick={togglePassword} className="is-clickable">
              {passwordShown ? (
                <FontAwesomeIcon
                  iconClassName="FaEyeSlash"
                  iconContextProps={{
                    className: 'has-text-primary ',
                  }}
                />
              ) : (
                <FontAwesomeIcon
                  iconClassName="FaEye"
                  iconContextProps={{
                    className: 'has-text-primary ',
                  }}
                />
              )}
            </a>
          </span>
        </div>
      ) : (
        <Field type="input" name={name} id={name} as={Input} />
      )}

      {errors[name] ? (
        <div className="ErrorMessage is-flex is-align-items-center">
          {GetErrorMessageIcon()}
          {errors[name]}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};
